<template>
  <section class="section-login">
    <template v-if="registerFrom === 'registerPage'">
      <div class="row">
        <div class="col-12">
          <button class="button-large button-block button-login -indigo"
                  @click="preLogin('facebook')">
            <i class="fab fa-facebook-f"></i>&nbsp;&nbsp;&nbsp;<label>{{ $t('message.register.register_with_facebook')
            }}</label>
          </button>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <button class="button-large button-block button-login -red"
                  @click="preLogin('googleplus')">
            <i class="fab fa-google"></i>&nbsp;&nbsp;&nbsp;<label>{{ $t('message.register.register_with_google')
            }}</label>
          </button>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <button class="button-large button-block button-login" @click="preLogin('apple')">
            <i class="fab fa-apple"></i>&nbsp;&nbsp;&nbsp;<label>{{ $t('message.login.login_with_apple') }}</label>
          </button>
        </div>
      </div>
    </template>
    <div class="row" v-else>
      <div class="col-12">
        {{ $t('message.login.sign_up_with') }}
        <a href="" @click.prevent="preLogin('facebook')">Facebook</a>,&nbsp;<a href="" @click.prevent="preLogin('googleplus')">Google</a>
        {{ $t('message.login.or') }}
        <a href="" @click.prevent="preLogin('apple')">Apple</a>
      </div>
    </div>
    <div class="background my-3">
      <span>{{ $t('message.login.or') }}</span>
    </div>
    <div class="row">
      <div class="col-12 text-left">
        <div class="form-group">
          <input type="email"
                 class="form-control input-lg"
                 :class="{'form-alert': errorEmail}"
                 @input="updateFormData('email', $event)"
                 :placeholder="$t('message.login.email')"
                 v-model="userData.email">
          <div v-if="errorEmail" class="form-alert-text -status-alert">{{ errorEmailText }}
          </div>
        </div>
        <div class="form-group">
          <input type="text"
                 class="form-control input-lg"
                 :class="{'form-alert': errorFirstName}"
                 @input="updateFormData('firstname', $event)"
                 :placeholder="$t('message.login.firstname')"
                 v-model="userData.firstname">
          <div v-if="errorFirstName" class="form-alert-text -status-alert">
            {{ $t('message.login.firstname_is_required') }}
          </div>
        </div>
        <div class="form-group">
          <input type="email"
                 class="form-control input-lg"
                 :class="{'form-alert': errorLastName}"
                 @input="updateFormData('lastname', $event)"
                 :placeholder="$t('message.login.lastname')"
                 v-model="userData.lastname">
          <div v-if="errorLastName" class="form-alert-text -status-alert">{{ $t('message.login.lastname_is_required')
            }}
          </div>
        </div>
        <div class="form-group">
          <input type="password"
                 maxlength="20"
                 class="form-control input-lg"
                 :class="{'form-alert': errorPassword}"
                 @input="updateFormData('password', $event)"
                 :placeholder="$t('message.login.password')"
                 v-model="userData.password">
          <div v-if="errorPassword" class="form-alert-text -status-alert">
            {{ errorPasswordText }}
          </div>
        </div>
        <div class="form-group">
          <div class="accept-term-text">
            {{ $t('message.login.clicking_sign_up') }}
            <a href="/term" target="_blank">{{ $t('message.footer.terms_and_conditions') }}</a>
            {{ $t('message.login.and') }}
            <a href="/privacy" target="_blank">{{ $t('message.footer.privacy_policy') }}</a>
          </div>
          <button class="button-large button-block -cyan"
                  :disabled="state.isRegistering"
                  @click="performRegister">
            <label>{{ $t(isRegistering) }}</label>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { SweetModal } from 'sweet-modal-vue'
import { createUserWithEmailAndPassword, signInWithRedirect, FacebookAuthProvider, GoogleAuthProvider, OAuthProvider, updateProfile } from 'firebase/auth'
import { firebaseAuth } from '../../helpers/firebaseHelpers'
import userEventLogHelpers from '../../helpers/userEventLogHelpers'
import loginHelpers from '../../helpers/loginHelpers'

export default {
  props: {
    registerFrom: String
  },
  components: {
    SweetModal
  },
  data () {
    return {
      userData: {
        email: null,
        firstname: null,
        lastname: null,
        password: null,
        picture: 'https://beneat.co/static/img/unknown.png',
        social_name: 'email_password',
        token: null
      },
      errorEmailText: null,
      errorPasswordText: null,
      errorEmail: false,
      errorFirstName: false,
      errorLastName: false,
      errorPassword: false
    }
  },
  computed: {
    ...mapGetters({
      isRegistering: 'auth/isRegistering',
      state: 'auth/getState',
      user: 'auth/getUser',
      referralCode: 'auth/getReferralCode'
    })
  },
  methods: {
    showAlertMessage (message) {
      this.$parent.$parent.showAlertMessage(message)
    },
    validation () {
      let result = true
      const emailFormat = new RegExp('^([a-zA-Z0-9\\+_\\-]+)(\\.[a-zA-Z0-9\\+_\\-]+)*@([a-z0-9\\-]+\\.)+[a-z]{2,6}$')
      // const passwordFormat = new RegExp('^(?=.*\\d)(?=.*[a-z])[0-9a-zA-Z]{6,}$')
      if (!this.userData.email) {
        this.errorEmailText = this.$i18n.t('message.login.email_is_required')
        this.errorEmail = true
        result = false
      } else if (this.userData.email && !emailFormat.test(this.userData.email)) {
        this.errorEmailText = this.$i18n.t('message.login.invalid_email_address')
        this.errorEmail = true
        result = false
      }

      if (!this.userData.firstname) {
        this.errorFirstName = true
        result = false
      }
      if (!this.userData.lastname) {
        this.errorLastName = true
        result = false
      }
      if (!this.userData.password) {
        this.errorPasswordText = this.$i18n.t('message.login.password_is_required')
        this.errorPassword = true
        result = false
      } else if (this.userData.password && this.userData.password.length < 6) {
        this.errorPasswordText = this.$i18n.t('message.login.invalid_password')
        this.errorPassword = true
        result = false
      }

      return result
    },
    updateFormData (attribute, e) {
      if (attribute === 'email') {
        this.errorEmail = false
      } else if (attribute === 'firstname') {
        this.errorFirstName = false
      } else if (attribute === 'lastname') {
        this.errorLastName = false
      } else {
        this.errorPassword = false
      }
    },
    async performRegister () {
      if (this.validation()) {
        const nonce = await loginHelpers.getNonce()
        if (nonce) {
          this.$store.commit('auth/SET_IS_REGISTERING', true)
          const email = this.userData.email
          const password = this.userData.password
          const name = this.userData.firstname + ' ' + this.userData.lastname
          createUserWithEmailAndPassword(firebaseAuth, email, password)
            .then((userCredential) => {
              updateProfile(userCredential.user, {
                displayName: name
              }).then(() => {
                let submitData = {
                  ...this.userData,
                  referral_code: this.referralCode,
                  nonce: nonce
                }
                this.$store.dispatch('auth/REGISTER', submitData)
                // Clear form data when registering from register page
                if (this.registerFrom === 'registerPage') {
                  this.clearForm()
                }
                // Track Line Event
                this.$lineTrack('Conversion')
              }).catch((error) => {
                this.$store.commit('auth/SET_IS_REGISTERING', false)
                this.showAlertMessage(error.message)
              })
            })
            .catch(error => {
              console.log('error register', error)
              if (error.code) {
                // Handle Errors here.
                this.$store.commit('auth/SET_IS_REGISTERING', false)
                this.showAlertMessage(this.$i18n.t('message.alert.email_is_registered'))
              }
            })
        }
      }
    },
    preLogin (type) {
      let provider
      if (type === 'facebook') {
        provider = new FacebookAuthProvider()
        provider.addScope('email')
      } else if (type === 'googleplus') {
        provider = new GoogleAuthProvider()
        provider.addScope('profile')
      } else if (type === 'apple') {
        provider = new OAuthProvider('apple.com')
        provider.addScope('email')
      }
      signInWithRedirect(firebaseAuth, provider)
      // Save user event log
      userEventLogHelpers.logEvent('sign_up', {
        method: type
      })
      window.localStorage.setItem('isLoggingIn', 'true')
    },
    clearForm () {
      this.$store.commit('auth/SET_IS_REGISTERING', false)
      this.$store.commit('auth/SET_REGISTER_SUCCESS_PAGE', true)
      this.clearUserData()
    },
    clearUserData () {
      this.userData.email = null
      this.userData.firstname = null
      this.userData.lastname = null
      this.userData.password = null
    }
  },
  mounted () {
    this.$store.commit('auth/SET_REGISTER_FROM', this.registerFrom)
    this.$store.commit('auth/SET_IS_REGISTERING', false)
    this.clearUserData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login/RegisterForm.vue